import React from 'react';
import { TagWrapper } from './styles';

export default function StatusTag({ tagName }) {
  return <TagWrapper>{tagName}</TagWrapper>;
}
